import React, { useState } from "react";
import "./BlogBanner.scss";
import blogBannerImage from "../../Assets/Blog/old-woman-working-home-office-illustration.webp";

const BlogBanner = () => {
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className={`blog-page aln_Pos ${imageLoaded ? "is-ready" : ""}`}>
      <img
        src={blogBannerImage}
        alt="blog banner"
        className="blog-page-bg"
        fetchPriority="high"
        loading="eager"
        decoding="async"
        onLoad={() => setImageLoaded(true)}
      />

      <div className="blog-page-overlay"></div>

      <div className="pa_25_ blog-page-text">
        <div className="max_Width">
          <h1 className="blog-banner-title">
            Discover the Best Stories from Our Bloggers <span>!</span>
          </h1>
          <p className="blog-banner-description">
            From cloud computing, and AI to the big data of the digital world,
            the trends evolve here. Stay updated, stay inspired!
          </p>
        </div>
      </div>
    </div>
  );
};

export default BlogBanner;